// extracted by mini-css-extract-plugin
module.exports = {"socialInsightList":"SocialInsightList__socialInsightList__HXdo9","insight":"SocialInsightList__insight__bOHB1"};